import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ThemeProvider } from 'styled-components'

import { BaseApp, theme, useSetLanguage } from '@reveni-io/reveni-ui'

import AppContext from './context/AppContext'
import initValue from './context/initValue'
import useIframeTheme from './hooks/useIframeTheme/useIframeTheme'
import Router from './Router/Router'
import { availableLanguages } from './constants'
import { getLocalStorage, saveLocalStorage } from './helpers'

function App() {
  const [context, setContext] = useState(getLocalStorage('context') || initValue)
  const { i18n } = useTranslation()
  const { iframeTheme } = useIframeTheme()

  useEffect(() => {
    saveLocalStorage('context', context)
  }, [context])

  useSetLanguage(availableLanguages, i18n.language)

  const mergedContext = iframeTheme
    ? {
        ...context,
        merchantInfo: {
          ...context.merchantInfo,
          theme: { ...context.merchantInfo?.theme, ...iframeTheme },
        },
      }
    : context

  return (
    <BaseApp>
      <ThemeProvider theme={theme}>
        <AppContext.Provider value={{ context: mergedContext, setContext }}>
          <Router />
        </AppContext.Provider>
      </ThemeProvider>
    </BaseApp>
  )
}

export default App
